<script lang="ts" >
  import Link from "svelte-link";
  import { ATTACHMENTS, DownloadAll, href } from "../../../../utils/Constant/Constant";
  import { Image } from "sveltestrap";
  import EmailFooter from "./EmailFooter.svelte";
  let imgPath:string = "/assets/images/email"

</script>
<div class="emailread-group">
    <h6 class="text-muted mb-0">
        <i class="icofont icofont-clip"></i> {ATTACHMENTS}
    </h6>
    <Link class="text-muted text-end right-download font-primary f-w-600" href={href}>
        <i class="fa fa-long-arrow-down me-2"></i>{DownloadAll}
    </Link>
    <div class="clearfix"></div>
    <div class="attachment">
        <ul>
            <li><Image fluid src="{imgPath}/1.jpg" alt="" /></li>
            <li><Image fluid src="{imgPath}/2.jpg" alt="" /></li>
            <li><Image fluid src="{imgPath}/3.jpg" alt="" /></li>
        </ul>
    </div>
    <EmailFooter />
</div>